import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Languages = (props) => (
  <Icon viewBox="0 0 18 18" {...props}>
    <g>
      <defs/>
      <path id="lang" d="M12.255 1.674a9.043 9.043 0 0 0-1.285-.15c-.157-.008-.311-.024-.47-.024h-.011a9 9 0 0 0 0 18h.011c.159 0 .313-.016.47-.024a8.993 8.993 0 0 0 1.285-17.802zM17.909 7.5h-3.64a12.071 12.071 0 0 0-2.769-5 8.5 8.5 0 0 1 6.409 5zm-4.409 3a11.029 11.029 0 0 1-.2 2H7.755a8.661 8.661 0 0 1-.255-2 8.661 8.661 0 0 1 .255-2H13.3a11.03 11.03 0 0 1 .2 2zm-3 7.5a13.345 13.345 0 0 1-2.454-4.5h5.028A11.634 11.634 0 0 1 10.5 18zM8.046 7.5A13.344 13.344 0 0 1 10.5 3a11.634 11.634 0 0 1 2.574 4.5H8.046zm1.454-5a13.758 13.758 0 0 0-2.675 5H3.09a8.235 8.235 0 0 1 6.41-5zm-6.74 6h3.83a10.8 10.8 0 0 0-.2 2 10.8 10.8 0 0 0 .2 2H2.76a7.815 7.815 0 0 1 0-4zm.33 5h3.735a13.758 13.758 0 0 0 2.675 5 8.236 8.236 0 0 1-6.41-5zm8.41 5a11.322 11.322 0 0 0 2.769-5h3.64c-1 2.457-3.753 4.844-6.409 5zm6.743-6h-3.788a13.683 13.683 0 0 0 .156-2 13.7 13.7 0 0 0-.111-2h3.743a7.908 7.908 0 0 1 0 4z"
        transform="translate(-1.5 -1.5)" className="cls-1" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Languages;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Languages.js